module.exports = __webpack_public_path__ + "img/KinokoTable75.f6a32d80.jpg";